import axios from 'axios'
import Cookies from 'js-cookie'
import store, { actionCreators } from '../store'
import { TOKEN_KEY } from '../constants'
import { params } from 'util/params'

export const baseURL = '/api'
axios.defaults.baseURL = baseURL
axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  const token = params('token') // 小程序端token通过url传递过来
  config.headers = Object.assign({
    'X-Requested-With': 'XMLHttpRequest',
    'X-Token': Cookies.get(TOKEN_KEY)
  }, config.headers)
  if (token && !config.headers['X-Token']) {
    config.headers.token = token
  }
  return config
})

axios.interceptors.response.use(response => {
  const data = response.data
  if (data.code) {
    if (Number(data.code) === 401) {
      Cookies.remove(TOKEN_KEY, { path: '', domain: '.simboss.com' })
      store.dispatch(actionCreators.setLoginStatus(false))
      setTimeout(() => {
        window.location.href = '/#login'
      })
    }
    if (Number(data.code) === 403) {
      window.location.href = '/#finance/renew'
    }
  }
  return data
})

export const get = (url, params, options) => {
  return axios.get(url, { params, ...options })
}

export const post = (url, data, options) => {
  return axios.post(url, data, options)
}
